import { Link } from "react-router-dom";
import Wrapper from "../../components/sectionWrapper";
import { media } from "../../libs/media";
import Messages from "./translations/CheckOutSimply.json";
import { Icon } from "@iconify/react";
// import Messages from "./translations/Secure.json";
import { useLangContext } from "../../components/translateContext";
// import buttonText from "../../translations/button.json";
export default function CheckOutSimply() {
  const { Lang } = useLangContext();
  const Infos = { msg: Messages[Lang] };
  return (
    <Wrapper childrenClassName="mb-20 relative" className="bg-white md:pb-6">
      <div className="relative  flex mb-8 align-center justify-center   text-center  ">
        <div className="w-full flex justify-center items-center align-center">
          <div className="">
            <p className="text-qosblackText  font-bold md:leading-40 md:text-Nw2 md:pt-24  ">
              {Infos.msg.HelloText} <br />
              {Infos.msg.HelloText1}
            </p>
            <p className="text-qosblackgray font-normal md:text-Mobilw22 mt-2  my-2 md:mt-0 w-full md:px-20  md:py-4 ">
              {Infos.msg.description}
            </p>
          </div>
        </div>
      </div>
      <div className=" grid gap-2 md:flex  md:items-start">
        <div className="w-full ">
          <div className="flex justify-center align-center items-center  w-full  p-10">
            <div className="bg-qosicon rounded-full p-10">
              <Icon
                icon="material-symbols:person-outline"
                height={100}
                style={{ color: "#0C0E45", fontSize: "20px" }}
              />
            </div>
          </div>

          <div className="flex gap-4 ">
          <div className="bg-qosorange rounded-full">

            <Icon
              icon="mdi:number-1"
              height={40}
              style={{ color: "white", fontSize: "20px" }}
            />
          </div>
            <p className="mt-3 md:mt-0 text-qosblackText font-bold leading-42 md:text-Mobi28 ">
              {Infos.msg.Scalable}
            </p>
          </div>
          <div>
            <p className="text-qosblackgray p-1 md:px-4 mt-2 font-normal eading-8 mdtext-Mobilw24 md:mt-4 md:px-4">
              {Infos.msg.ScalableText}
            </p>
          </div>
        </div>
        <div className="w-full ">
          <div className="flex justify-center align-center items-center  w-full  p-10">
            <div className="bg-qosicon rounded-full p-10">
              <Icon
                icon="ic:outline-settings"
                height={100}
                style={{ color: "#0C0E45", fontSize: "20px" }}
              />
            </div>
          </div>
          <div className="flex gap-4 ">
            <div className="bg-qosorange rounded-full">

            <Icon
              icon="mdi:number-2"
              height={40}
              style={{ color: "white", fontSize: "20px" }}
            />
            </div>
            <p className="mt-3 md:mt-0 text-qosblackText font-bold leading-42 md:text-Mobilw24 ">
            {Infos.msg.No}
            </p>
          </div>
          <div>
            <p className="text-qosblackgray p-1 md:px-4  mt-2 font-normal eading-8 mdtext-Mobilw24 md:mt-4 ">
              {Infos.msg.NoText}
            </p>
          </div>
        </div>
        <div className="w-full ">
          <div className="flex justify-center align-center items-center  w-full  p-10">
            <div className="bg-qosicon rounded-full p-10">
              <Icon
                icon="carbon:code"
                height={100}
                style={{ color: "#0C0E45", fontSize: "20px" }}
              />
            </div>
          </div>
          <div className="flex gap-4 ">
          <div className="bg-qosorange rounded-full">

            <Icon
              icon="mdi:number-3"
              height={40}
              style={{ color: "white", fontSize: "20px" }}
            />
          </div>
            <p className="mt-3 md:mt-0 text-qosblackText font-bold leading-42 md:text-Mobi28 ">
              {Infos.msg.Easy}
            </p>
          </div>
          <div>
            <p className="text-qosblackgray mt-2 p-1 md:px-4  font-normal eading-8 mdtext-Mobilw24 md:mt-4">
              {Infos.msg.EasyText}
            </p>
          </div>
        </div>
      </div>

      {/* <div className="w-2/5 md:mt-6">
        <div className="w-full h-full">
          <img src={media.Logos.Ussd.ussdTop} alt="" className="" />
        </div>
      </div> */}
    </Wrapper>
  );
}
